// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"553becf0","160":"09a66a33","208":"846a5f18","293":"1c1ee6b4","516":"91f1cd52","519":"897d1653","917":"4ec96b37","946":"23b7bcf0"}[chunkId] + ".chunk.js";
};